module.exports = __webpack_public_path__ + "img/web4.2606425f.png";